import LeaderBoard from "../components/LeaderBoard";

function LeaderboardsPage() {
    return (
        <LeaderBoard />
    );
}

export default LeaderboardsPage;